import React, { useState, useEffect } from 'react'
import { Table, Icon, Panel, Row, Col, Input, SelectPicker } from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function AssetBookingListsTable({
  schema,
  loading,
  onReload = () => {},
  onSelect = () => {},
  onViewFiles = () => {},
  onSearch = () => {},
  lengthMenu,
  searchForm,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [tableData, setTableData] = useState([])
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [assetCode, setAssetCode] = useState()
  const [assetName, setAssetName] = useState()
  const [assetType, setAssetType] = useState()
  const [project, setProject] = useState()
  const [reserveDocNo, setReserveDocNo] = useState()

  const fs = localStorage.getItem('fontSize')
  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload({}, dataKey, displayLength)
    }
  }

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload({}, 1, dataKey)
    }
  }

  const handleSearch = async () => {
    console.log('handleSearch')

    let request = {
      assetCode: assetCode,
      assetName: assetName,
      project: project,
      assetType: assetType,
      reserveDocNo: reserveDocNo,
    }
    onSearch(request, 1, displayLength)
  }

  const handleCancel = async () => {
    console.log('handleCancel')
    setAssetCode('')
    setAssetName('')
    setAssetType('')
    setProject('')
    setReserveDocNo('')
    setDisplayLength(5)
    onSearch({}, 1, 5)
  }

  return (
    <>
      <Panel header={`${searchForm.header || 'ค้นหา'}`} bordered collapsible defaultExpanded>
        <Row style={{ marginTop: -10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.assetCode.label}
            <Input
              placeholder={searchForm.assetCode.hint || searchForm.assetCode.label}
              value={assetCode}
              onChange={(value) => {
                setAssetCode(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.assetName.label}
            <Input
              placeholder={searchForm.assetName.hint || searchForm.assetName.label}
              value={assetName}
              onChange={(value) => {
                setAssetName(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.assetType.label}
            <SelectPicker
              searchable={false}
              data={searchForm.assetType.options}
              value={assetType}
              block
              placeholder={`เลือก${searchForm.assetType.label || ''}`}
              onChange={(value) => {
                setAssetType(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.project.label}
            <Input
              placeholder={searchForm.project.hint || searchForm.project.label}
              value={project}
              onChange={(value) => {
                setProject(value)
              }}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {searchForm.reserveDocNo.label}
            <Input
              placeholder={searchForm.reserveDocNo.hint || searchForm.reserveDocNo.label}
              value={reserveDocNo}
              onChange={(value) => {
                setReserveDocNo(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <div style={{ marginTop: 26 }}>
              <SearchButton
                disabled={loading}
                onClick={handleSearch}
                style={{ marginTop: 0, marginLeft: 0 }}
              >
                ค้นหา
              </SearchButton>
              <CancelButton onClick={handleCancel} style={{ marginTop: 0, marginLeft: 10 }}>
                ยกเลิก
              </CancelButton>
            </div>
          </Col>

          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>
      </Panel>

      <Panel collapsible defaultExpanded header={' '} bordered style={{ marginTop: 20 }}>
        <Table
          wordWrap
          minHeight={400}
          autoHeight
          loading={loading}
          headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
          data={tableData || []}
          style={{ marginTop: '10px' }}
        >
          <Column width={100} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return (page - 1) * displayLength + index + 1
              }}
            </Cell>
          </Column>

          <Column width={140}>
            <HeaderCell>เลขที่คำขอจอง</HeaderCell>
            <Cell dataKey="reserveDocNo" />
          </Column>

          <Column width={180}>
            <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
            <Cell dataKey="assetCode" />
          </Column>

          <Column width={200}>
            <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
            <Cell dataKey="assetName" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>วันที่ขอจอง</HeaderCell>
            <Cell dataKey="reserveDate" />
          </Column>

          <Column width={160} align="center">
            <HeaderCell>วันที่หมดอายุการจอง</HeaderCell>
            <Cell dataKey="reserveExpiredDate" />
          </Column>

          <Column width={140}>
            <HeaderCell style={{ textAlign: 'center' }}>ราคา/หน่วย</HeaderCell>
            {/* <Cell dataKey="assetAmount" /> */}
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return budgetFormat(rowData.assetAmount)
              }}
            </Cell>
          </Column>

          <Column width={160}>
            <HeaderCell>รุ่น</HeaderCell>
            <Cell dataKey="assetModel" />
          </Column>

          <Column width={160}>
            <HeaderCell>ยี่ห้อ</HeaderCell>
            <Cell dataKey="assetBrand" />
          </Column>

          <Column width={160}>
            <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
            <Cell dataKey="assetType" />
          </Column>

          <Column width={150}>
            <HeaderCell>รูปภาพครุภัณฑ์</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <a
                      style={{ cursor: 'pointer', textDecorationLine: 'underline' }}
                      onClick={(_) => {
                        // console.log(rowData)
                        onViewFiles(`${rowData?.assetCode || '__'}`, rowData?.assetImg || null)
                      }}
                    >
                      <Icon icon="file-image-o" style={{ marginRight: '5px' }} />
                      คลิกดูรูปภาพ
                    </a>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>

        <TablePagination
          lengthMenu={lengthMenu || defaultLengthMenu}
          activePage={page || defaultPage}
          renderLengthMenu={(lengthMenu) => {
            return (
              <>
                {lengthMenu}
                {`รายการ/หน้า`}
              </>
            )
          }}
          renderTotal={(total) => {
            return <>{` ทั้งหมด ${total || 0} รายการ`}</>
          }}
          displayLength={displayLength || 5}
          total={schema.totalSize}
          onChangePage={handleChangePage}
          onChangeLength={handleChangeLength}
        />
      </Panel>
    </>
  )
}
